<lib-site-setup-navbar
  [stepNumber]="StepNumberEnum.InstallOptions"
  class="w-full"
  [loggedInUser]="vm().currentUser"
  [isNewModalDesign]="true"
  [hasBackButton]="false"
  [hasUserProfile]="false"
/>

<div class="flex flex-col gap-5">
  <div
    class="mt-2 font-poppins text-[24px] font-medium leading-[34px] tracking-[-0.7px] text-[#595959] xs:text-[30px] xs:leading-[45px]"
  >
    <span>{{ 'site_setup_install_options_title_part1' | translate }}</span>&nbsp;<span class="text-background">{{
      'site_setup_install_options_title_part2' | translate
    }}</span>
  </div>

  <p id="install-options-subtitle" class="font-poppins text-[16px] font-light leading-[24px] text-[#969696]">
    {{ 'site_setup_install_options_subtitle' | translate }}
  </p>

  <fieldset
    class="m-0 flex min-w-0 flex-col gap-3 border-0 p-0"
    aria-labelledby="install-options-subtitle"
    [attr.aria-describedby]="submitted && !selection ? 'install-options-error' : null"
  >
    <label
      class="flex w-full cursor-pointer flex-col items-start gap-3 rounded-3xl border border-background-disabled p-4 text-start has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-primary-blue has-[:focus-visible]:ring-offset-2 xs:flex-row xs:items-center xs:gap-4"
      [class.border-primary-blue]="selection === InstallOptionEnum.CONTACT_IT_PROVIDER"
      [class.border-states-red]="submitted && !selection"
    >
      <input
        type="radio"
        class="sr-only"
        name="installOption"
        [value]="InstallOptionEnum.CONTACT_IT_PROVIDER"
        [checked]="selection === InstallOptionEnum.CONTACT_IT_PROVIDER"
        [attr.aria-invalid]="submitted && !selection ? 'true' : null"
        (change)="select(InstallOptionEnum.CONTACT_IT_PROVIDER)"
      />
      <div class="flex aspect-square h-18 shrink-0 items-center justify-center rounded-full bg-background-light-blue text-primary-blue">
        <svg-icon key="px-24-admin" [fontSize]="'37px'" />
      </div>
      <div class="flex flex-col gap-2">
        <p class="font-poppins text-[18px] font-medium leading-[24px] text-[#595959]">
          {{ 'site_setup_install_options_contact_title' | translate }}
        </p>
        <p class="font-poppins text-[16px] font-light leading-[24px] text-[#969696]">
          {{ 'site_setup_install_options_contact_description' | translate }}
        </p>
      </div>
    </label>

    <label
      class="flex w-full cursor-pointer flex-col items-start gap-3 rounded-3xl border border-background-disabled p-4 text-start has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-primary-blue has-[:focus-visible]:ring-offset-2 xs:flex-row xs:items-center xs:gap-4"
      [class.border-primary-blue]="selection === InstallOptionEnum.SELF_INSTALL"
      [class.border-states-red]="submitted && !selection"
    >
      <input
        type="radio"
        class="sr-only"
        name="installOption"
        [value]="InstallOptionEnum.SELF_INSTALL"
        [checked]="selection === InstallOptionEnum.SELF_INSTALL"
        [attr.aria-invalid]="submitted && !selection ? 'true' : null"
        (change)="select(InstallOptionEnum.SELF_INSTALL)"
      />
      <div class="flex aspect-square h-18 shrink-0 items-center justify-center rounded-full bg-background-light-blue text-primary-blue">
        <svg-icon key="px-24-download" [fontSize]="'37px'" />
      </div>
      <div class="flex flex-col gap-2">
        <p class="font-poppins text-[18px] font-medium leading-[24px] text-[#595959]">
          {{ 'site_setup_install_options_self_title' | translate }}
        </p>
        <p class="font-poppins text-[16px] font-light leading-[24px] text-[#969696]">
          {{ 'site_setup_install_options_self_description' | translate }}
        </p>
        <p class="font-poppins text-[16px] font-medium leading-[24px] text-primary-blue">
          {{ 'site_setup_install_options_self_help' | translate }}
        </p>
      </div>
    </label>

    @if (submitted && !selection) {
      <p id="install-options-error" role="alert" class="typo-h7-book text-states-red">
        {{ 'site_setup_install_options_required' | translate }}
      </p>
    }
  </fieldset>

  <button class="btn-primary mt-4 flex h-[46px] w-full items-center justify-center" type="button" (click)="next()">
    {{ 'site_setup_it_provider_next' | translate }}
  </button>

  <div class="flex items-center gap-1 text-[#595959]">
    <svg-icon key="px-24-locked" size="sm" />
    <p class="font-poppins text-[12px] font-normal leading-[24px]">
      {{ 'site_setup_it_provider_security_note_1' | translate }}
    </p>
  </div>
</div>
